<script>
export let number
</script>

<p>
  got it: {number}
</p>